import React, {Component} from 'react';
import {connect} from 'react-redux';
import store from 'store';

import {
    Button,
    Col,
    Row
} from 'reactstrap';
import {Link} from 'react-router';

import PolyUtil from "../../../util/PolyUtil";
import WidePropertyCard from "../../../components/properties/WidePropertyCard";
import UserBubble from "../../../components/user/UserBubble";
import Loader from "../../../components/display/Loader";

class TenantGroupListingModule extends Component {

    render() {
        if (this.props.applied_listings) {
            const {applied_listings} = this.props;

            const nonArchivedListings = applied_listings.filter((listing) => {
                return !listing.archived;
            });

            return PolyUtil.validArr(nonArchivedListings) ? (
                <div>
                    <h3 className="mt-5 mt-0">Applications</h3>
                    <hr/>
                    {
                        nonArchivedListings.map(function (listing, i) {
                            return (
                                <WidePropertyCard
                                    key={i}
                                    display_address={PolyUtil.getPropertyStreetAddress(listing.prop)}
                                    identifier={listing.prop.identifier}
                                    city={PolyUtil.getPropertyCity(listing.prop)}
                                    state={PolyUtil.getPropertyState(listing.prop)}
                                    image={listing.prop.image}
                                    propertyUrl={"/listings/" + listing.apply_key + "/"}
                                >
                                    <Row className="d-flex justify-content-center my-auto">
                                        <Col md={8} className="d-flex justify-content-center align-items-start mb-3 mb-md-0">
                                            {
                                                listing.application_statuses.map(function (app, h) {
                                                    return (
                                                        <UserBubble key={h}
                                                                    label={(!app.applied ? "⚠ " : "") + app.get_first_name}
                                                                    initials={app.get_first_name.charAt(0) + "" + app.get_last_name.charAt(0)}
                                                                    color={app.applied ? 'success' : 'warning'}
                                                                    dark
                                                                    short
                                                                    popover={{title: "Application status:", content: app.applied ? 'Applied' : 'Not applied'}}/>
                                                    );
                                                })
                                            }
                                        </Col>
                                        <Col md={4} className="d-flex justify-content-center align-items-center">
                                            <Button color="primary" tag={Link} to={"/listings/" + listing.apply_key + "/"} onClick={() => store.set('prev', 'dashboard')} outline>View Listing</Button>
                                        </Col>
                                    </Row>
                                </WidePropertyCard>
                            );
                        })
                    }
                </div>
            ) : null;
        } else {
            return (<Loader spin isLoading/> );
        }
    }
}

const mapStateToProps = (state) => ({
    applied_listings: state.tenant.roommate_group.applied_listings
});

export default connect(mapStateToProps)(TenantGroupListingModule);



// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/TenantGroupListingModule.js